import type { SqliteAsyncConnection } from '../../../../shared/localDb';
import { getCatalogRamSnapshotCache } from '../../../../catalog/infra/catalogRamSnapshotCache';
export type StockRowLookup = {
  id: string;
  quantity: number;
  avg_cost: number;
};

/** Resuelve la fila stocks para producto+sucursal, opcionalmente por celda de variante. */
export function stockRowSqlFilter(variantId?: string | null): string {
  return variantId ? 'variant_id = ?' : 'variant_id IS NULL';
}

function findStockRowInWebCache(
  productId: string,
  branchId: string,
  variantId?: string | null,
): StockRowLookup | null {
  const stocks = getCatalogRamSnapshotCache()?.stocks ?? [];
  const row = stocks.find((s) => {
    if (s.product_id !== productId || s.branch_id !== branchId) return false;
    const rowVariantId = (s as { variant_id?: string | null }).variant_id ?? null;
    if (variantId) return rowVariantId === variantId;
    return rowVariantId == null || rowVariantId === '';
  });
  if (!row) return null;
  return {
    id: String(row.id ?? `${row.product_id}:${row.branch_id}`),
    quantity: Number(row.quantity ?? 0),
    avg_cost: Number(row.avg_cost ?? 0),
  };
}

export async function findStockRow(
  productId: string,
  branchId: string,
  variantId?: string | null,
  _conn?: SqliteAsyncConnection,
): Promise<StockRowLookup | null> {
  return findStockRowInWebCache(productId, branchId, variantId);
}

/** Mantiene la fila padre como SUM de celdas de variante (SQLite local). */
export async function maintainParentStockSum(
  _conn: SqliteAsyncConnection,
  _productId: string,
  _branchId: string,
): Promise<void> {
  // ADR-017 Fase 4: SQLite local eliminado — dead code bajo stub no-op.
}

/** Encuentra todas las filas de stock de una variante, en todas las sucursales. */
export async function findStockRowsForVariant(
  productId: string,
  variantId: string,
): Promise<StockRowLookup[]> {
  const stocks = getCatalogRamSnapshotCache()?.stocks ?? [];
        return stocks
          .filter((s) => {
            if (s.product_id !== productId) return false;
            const rowVariantId = (s as { variant_id?: string | null }).variant_id ?? null;
            return rowVariantId === variantId;
          })
          .map((s) => ({
            id: String(s.id ?? `${s.product_id}:${s.branch_id}`),
            quantity: Number(s.quantity ?? 0),
            avg_cost: Number(s.avg_cost ?? 0),
          }));
}

/** Crea fila qty 0 para una celda de variante si no existe. */
export async function ensureVariantStockRow(
  conn: SqliteAsyncConnection,
  productId: string,
  branchId: string,
  variantId: string,
): Promise<string> {
  // ADR-017 Fase 4: SQLite local eliminado — dead code bajo stub no-op.
  const existing = await findStockRow(productId, branchId, variantId, conn);
  if (existing) return existing.id;
  return crypto.randomUUID();
}
